export default "__VITE_ASSET__CUdAObAF__"